import { Box } from "@/storybook-components";
import { humanize } from "@/lib";
import type { Project } from "@/types";
import Item from "@/theme/components/item";
import { useAppSelector } from "@/redux/store/hooks";

const ProjectTimestamp = ({ project }: { project: Project }): JSX.Element => {
  const { publishedAt } = project;
  const { queryFilter } = useAppSelector((state) => state.projectFinder);
  const { timestampFormat, locales } = queryFilter;

  return (
    <Item className="ehq-cardItem">
      <Box as="span" h="18px" className="ehq-projectYearTextContainer">
        {[
          locales["projects.timeStampText"],
          humanize(publishedAt, timestampFormat || "DD MMM YYYY")
        ].join(" ")}
      </Box>
    </Item>
  );
};

export default ProjectTimestamp;
